import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NOTIFICATIONS_PATH, PROFILE_PATH } from "../../../constants/env";
import useIsMobile from "../../../hooks/device/useIsMobile";
import { useNotificationApi } from "../../hooks/useNotificationApi";
import { useSearchModule } from "../../hooks/useSearchModule";
import { HeaderStore } from "../../stores/header";
import { SearchIcon } from "../BonusXIcons";
import { BellIcon } from "../BonusXIcons/BellIcon";
import { ProfileIcon } from "../BonusXIcons/ProfileIcon";
import { BoxCentered } from "../BoxCentered";
import { CountBadge } from "./CountBadge";

function IconWrapper({ onClick, children }: Readonly<{ onClick?: Function; children: React.ReactNode }>) {
  return (
    <BoxCentered
      css={{
        paddingRight: 12,
      }}
    >
      <IconButton
        onClick={() => {
          if (typeof onClick === "function") onClick();
        }}
      >
        {children}
      </IconButton>
    </BoxCentered>
  );
}

function NotificationBell() {
  const { error: errorNotification, data: notifications } = useNotificationApi({ type: "citizen" });
  const countNotification = notifications?.count || 0;

  useEffect(() => {
    if (errorNotification) console.error("errorNotification", errorNotification);
  }, [errorNotification]);

  return (
    <>
      <BellIcon />
      <CountBadge countNotification={countNotification} />
    </>
  );
}

export function VisibleActions() {
  const { visibleActions } = useAtomValue(HeaderStore);
  const navigate = useNavigate();
  const location = useLocation();
  const { reset } = useSearchModule();
  const isMobile = useIsMobile();

  const actionElements = visibleActions.filter((action) => typeof action !== "string");

  return (
    <Box
      css={{
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      {visibleActions.includes("profile") && (
        <IconWrapper onClick={() => navigate(PROFILE_PATH, { state: { from: location.pathname } })}>
          <ProfileIcon />
        </IconWrapper>
      )}
      {visibleActions.includes("search") && isMobile && (
        <span id="search-icon-component">
          <IconWrapper onClick={() => reset({ visible: true })}>
            <SearchIcon />
          </IconWrapper>
        </span>
      )}
      {visibleActions.includes("notification") && (
        <IconWrapper onClick={() => navigate(NOTIFICATIONS_PATH, { state: { from: location.pathname } })}>
          <NotificationBell />
        </IconWrapper>
      )}
      {actionElements}
    </Box>
  );
}
